import { Directive, ElementRef, Inject, Input, OnInit } from '@angular/core';
import { Environment, ENVIRONMENT } from "@qid/env";
import { AppName } from "../enum/app-name.enum";


@Directive({
  standalone: true,
  selector: '[hideForApp]'
})
export class HideForAppDirective implements OnInit {

  @Input() hideForApp: AppName | string;

  constructor(
    private el: ElementRef,
    @Inject(ENVIRONMENT) private env: Environment
  ) {
  }

  ngOnInit() {
    this.init()
  }

  async init() {

    if (this.hideForApp == this.env.appName) {
      this.hideElement()
    }

  }


  hideElement() {
    this.el.nativeElement.remove();
  }


}
